import { FC, PropsWithChildren } from 'react';
import Link from 'next/link';

type Properties = {
  className?: string;
} & {
  to: string;
  target?: '_self' | '_blank' | undefined;
  rel?: string;
  'aria-label'?: string;
} & PropsWithChildren;

const AppLink: FC<Properties> = ({ children, className, to, target, rel, 'aria-label': ariaLabel }) => {
  return (
    <Link href={to} className={className} target={target} rel={rel} aria-label={ariaLabel}>
      {children}
    </Link>
  );
};

export { AppLink };
